// User 

export var USER_LIST_LOADING_STARTED = 'USER_LIST_LOADING_STARTED';
export var USER_LIST_LOADING_FAILED = 'USER_LIST_LOADING_FAILED';
export var USER_LIST_LOADING_FINISHED = 'USER_LIST_LOADING_FINISHED';

// Upload

export var UPLOAD_FILE_STARTED = 'UPLOAD_FILE_STARTED';
export var UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED';
export var UPLOAD_FILE_FINISHED = 'UPLOAD_FILE_FINISHED';

// GDPR consent

export var GDPR_CONSENT_BY_LICENSE_LOADING_STARTED = "GDPR_CONSENT_BY_LICENSE_LOADING_STARTED";
export var GDPR_CONSENT_BY_LICENSE_LOADING_FAILED = "GDPR_CONSENT_BY_LICENSE_LOADING_FAILED";
export var GDPR_CONSENT_BY_LICENSE_LOADING_FINISHED = "GDPR_CONSENT_BY_LICENSE_LOADING_FINISHED";

export var GDPR_CONSENT_BY_LICENSE_SAVING_STARTED = "GDPR_CONSENT_BY_LICENSE_SAVING_STARTED";
export var GDPR_CONSENT_BY_LICENSE_SAVING_FAILED = "GDPR_CONSENT_BY_LICENSE_SAVING_FAILED";
export var GDPR_CONSENT_BY_LICENSE_SAVING_FINISHED = "GDPR_CONSENT_BY_LICENSE_SAVING_FINISHED";

// Panel

export var PANEL_LOADING_STARTED = 'PANEL_LOADING_STARTED';
export var PANEL_LOADING_FINISHED = 'PANEL_LOADING_FINISHED';
export var PANEL_LOADING_FAILED = 'PANEL_LOADING_FAILED';

export var PANEL_FOR_EXPORT_LOADING_STARTED = 'PANEL_FOR_EXPORT_LOADING_STARTED';
export var PANEL_FOR_EXPORT_LOADING_FINISHED = 'PANEL_FOR_EXPORT_LOADING_FINISHED';
export var PANEL_FOR_EXPORT_LOADING_FAILED = 'PANEL_FOR_EXPORT_LOADING_FAILED';

export var PANEL_ALL_LOADING_STARTED = 'PANEL_ALL_LOADING_STARTED';
export var PANEL_ALL_LOADING_FINISHED = 'PANEL_ALL_LOADING_FINISHED';
export var PANEL_ALL_LOADING_FAILED = 'PANEL_ALL_LOADING_FAILED';

// Address

export var ADDRESS_LIST_LOADING_STARTED = 'ADDRESS_LIST_LOADING_STARTED';
export var ADDRESS_LIST_LOADING_FINISHED = 'ADDRESS_LIST_LOADING_FINISHED';
export var ADDRESS_LIST_LOADING_FAILED = 'ADDRESS_LIST_LOADING_FAILED';

export var ADDRESS_LIST_BY_LICENSE_LOADING_STARTED = 'ADDRESS_LIST_BY_LICENSE_LOADING_STARTED';
export var ADDRESS_LIST_BY_LICENSE_LOADING_FAILED = 'ADDRESS_LIST_BY_LICENSE_LOADING_FAILED';
export var ADDRESS_LIST_BY_LICENSE_LOADING_FINISHED = 'ADDRESS_LIST_BY_LICENSE_LOADING_FINISHED';

// Targets

export var TARGET_LOADING_STARTED = 'TARGET_LOADING_STARTED';
export var TARGET_LOADING_FINISHED = 'TARGET_LOADING_FINISHED';
export var TARGET_LOADING_FAILED = 'TARGET_LOADING_FAILED';

export var TARGET_LIST_LOADING_STARTED = 'TARGET_LIST_LOADING_STARTED';
export var TARGET_LIST_LOADING_FINISHED = 'TARGET_LIST_LOADING_FINISHED';
export var TARGET_LIST_LOADING_FAILED = 'TARGET_LIST_LOADING_FAILED';

// Requests

export var REQUEST_ADD_NEW_TARGET_STARTED = 'REQUEST_ADD_NEW_TARGET_STARTED';
export var REQUEST_ADD_NEW_TARGET_FINISHED = 'REQUEST_ADD_NEW_TARGET_FINISHED';
export var REQUEST_ADD_NEW_TARGET_FAILED = 'REQUEST_ADD_NEW_TARGET_FAILED';

export var REQUEST_CHECK_LICENSE_STARTED = 'REQUEST_CHECK_LICENSE_STARTED';
export var REQUEST_CHECK_LICENSE_FINISHED = 'REQUEST_CHECK_LICENSE_FINISHED';
export var REQUEST_CHECK_LICENSE_FAILED = 'REQUEST_CHECK_LICENSE_FAILED';

export var REQUEST_ADD_NEW_ADDRESS_STARTED = 'REQUEST_ADD_NEW_ADDRESS_STARTED';
export var REQUEST_ADD_NEW_ADDRESS_FINISHED = 'REQUEST_ADD_NEW_ADDRESS_FINISHED';
export var REQUEST_ADD_NEW_ADDRESS_FAILED = 'REQUEST_ADD_NEW_ADDRESS_FAILED';

export var REQUEST_ADD_EXISTING_ADDRESS_STARTED = 'REQUEST_ADD_EXISTING_ADDRESS_STARTED';
export var REQUEST_ADD_EXISTING_ADDRESS_FINISHED = 'REQUEST_ADD_EXISTING_ADDRESS_FINISHED';
export var REQUEST_ADD_EXISTING_ADDRESS_FAILED = 'REQUEST_ADD_EXISTING_ADDRESS_FAILED';

export var REQUEST_REMOVING_STARTED= 'REQUEST_REMOVING_STARTED';
export var REQUEST_REMOVING_FAILED = 'REQUEST_REMOVING_FAILED';
export var REQUEST_REMOVING_FINISHED = 'REQUEST_REMOVING_FINISHED';

export var REQUEST_LIST_LOADING_STARTED = 'REQUEST_LIST_LOADING_STARTED';
export var REQUEST_LIST_LOADING_FINISHED = 'REQUEST_LIST_LOADING_FINISHED';
export var REQUEST_LIST_LOADING_FAILED = 'REQUEST_LIST_LOADING_FAILED';

export var REQUEST_ALL_LIST_LOADING_STARTED = 'REQUEST_ALL_LIST_LOADING_STARTED';
export var REQUEST_ALL_LIST_LOADING_FINISHED = 'REQUEST_ALL_LIST_LOADING_FINISHED';
export var REQUEST_ALL_LIST_LOADING_FAILED = 'REQUEST_ALL_LIST_LOADING_FAILED';

export var REQUEST_SETSTATUS_STARTED = 'REQUEST_SETSTATUS_STARTED';
export var REQUEST_SETSTATUS_FINISHED = 'REQUEST_SETSTATUS_FINISHED';
export var REQUEST_SETSTATUS_FAILED = 'REQUEST_SETSTATUS_FAILED';

// Profile

export var PROFILE_LOGIN_STARTED = 'PROFILE_LOGIN_STARTED';
export var PROFILE_LOGIN_FAILED = 'PROFILE_LOGIN_FAILED';
export var PROFILE_LOGIN_FINISHED = 'PROFILE_LOGIN_FINISHED';
export var PROFILE_LOGIN_MFA_REQUIRED = 'PROFILE_LOGIN_MFA_REQUIRED';
export var PROFILE_VERIFY_MFA_STARTED = 'PROFILE_VERIFY_MFA_STARTED';
export var PROFILE_VERIFY_MFA_FAILED = 'PROFILE_VERIFY_MFA_FAILED';
export var PROFILE_MFA_CANCELLED = 'PROFILE_MFA_CANCELLED';

export var PROFILE_LOGOUT = 'PROFILE_LOGOUT';
export var PROFILE_SESSION_EXTENDED = 'PROFILE_SESSION_EXTENDED';

// Panel changes

export var PANELCHANGES_LIST_LOADING_STARTED = 'PANELCHANGES_LIST_LOADING_STARTED';
export var PANELCHANGES_LIST_LOADING_FAILED = 'PANELCHANGES_LIST_LOADING_FAILED';
export var PANELCHANGES_LIST_LOADING_FINISHED = 'PANELCHANGES_LIST_LOADING_FINISHED';

export var PANELCHANGES_ALL_LIST_LOADING_STARTED = 'PANELCHANGES_ALL_LIST_LOADING_STARTED';
export var PANELCHANGES_ALL_LIST_LOADING_FAILED = 'PANELCHANGES_ALL_LIST_LOADING_FAILED';
export var PANELCHANGES_ALL_LIST_LOADING_FINISHED = 'PANELCHANGES_ALL_LIST_LOADING_FINISHED';

export var PANELCHANGE_REMOVING_STARTED = 'PANELCHANGE_REMOVING_STARTED';
export var PANELCHANGE_REMOVING_FAILED = 'PANELCHANGE_REMOVING_FAILED';
export var PANELCHANGE_REMOVING_FINISHED = 'PANELCHANGE_REMOVING_FINISHED';

export var PANELCHANGE_ADD_TARGET_STARTED = 'PANELCHANGE_ADD_TARGET_STARTED';
export var PANELCHANGE_ADD_TARGET_FINISHED = 'PANELCHANGE_ADD_TARGET_FINISHED';
export var PANELCHANGE_ADD_TARGET_FAILED = 'PANELCHANGE_ADD_TARGET_FAILED';

export var PANELCHANGE_MODIFY_TARGET_STARTED = 'PANELCHANGE_MODIFY_TARGET_STARTED';
export var PANELCHANGE_MODIFY_TARGET_FINISHED = 'PANELCHANGE_MODIFY_TARGET_FINISHED';
export var PANELCHANGE_MODIFY_TARGET_FAILED = 'PANELCHANGE_MODIFY_TARGET_FAILED';

export var PANELCHANGE_REMOVE_TARGET_STARTED= 'PANELCHANGE_REMOVE_TARGET_STARTED';
export var PANELCHANGE_REMOVE_TARGET_FAILED = 'PANELCHANGE_REMOVE_TARGET_FAILED';
export var PANELCHANGE_REMOVE_TARGET_FINISHED = 'PANELCHANGE_REMOVE_TARGET_FINISHED';


export var PANELCHANGE_SETSTATUS_STARTED = 'PANELCHANGE_SETSTATUS_STARTED';
export var PANELCHANGE_SETSTATUS_FAILED = 'PANELCHANGE_SETSTATUS_FAILED';
export var PANELCHANGE_SETSTATUS_FINISHED = 'PANELCHANGE_SETSTATUS_FINISHED';

// City

export var CITY_LIST_LOADING_STARTED = 'CITY_LIST_LOADING_STARTED';
export var CITY_LIST_LOADING_FAILED = 'CITY_LIST_LOADING_FAILED';
export var CITY_LIST_LOADING_FINISHED = 'CITY_LIST_LOADING_FINISHED';

export var CITY_WITH_POSTAL_CODE_LIST_LOADING_STARTED = 'CITY_WITH_POSTAL_CODE_LIST_LOADING_STARTED';
export var CITY_WITH_POSTAL_CODE_LIST_LOADING_FAILED = 'CITY_WITH_POSTAL_CODE_LIST_LOADING_FAILED';
export var CITY_WITH_POSTAL_CODE_LIST_LOADING_FINISHED = 'CITY_WITH_POSTAL_CODE_LIST_LOADING_FINISHED';

export var CITY_ZIP_DATA_LOADING_STARTED = 'CITY_ZIP_DATA_LOADING_STARTED';
export var CITY_ZIP_DATA_LOADING_FAILED = 'CITY_ZIP_DATA_LOADING_FAILED';
export var CITY_ZIP_DATA_LOADING_FINISHED = 'CITY_ZIP_DATA_LOADING_FINISHED';

// Targetgroups

export var TARGETGROUP_LIST_LOADING_STARTED = 'TARGETGROUP_LIST_LOADING_STARTED';
export var TARGETGROUP_LIST_LOADING_FINISHED = 'TARGETGROUP_LIST_LOADING_FINISHED';
export var TARGETGROUP_LIST_LOADING_FAILED = 'TARGETGROUP_LIST_LOADING_FAILED';

// Settings

export var SETTING_LOADING_STARTED = 'SETTING_LOADING_STARTED';
export var SETTING_LOADING_FAILED = 'SETTING_LOADING_FAILED';
export var SETTING_LOADING_FINISHED = 'SETTING_LOADING_FINISHED';

export var SETTING_SAVING_STARTED = 'SETTING_SAVING_STARTED';
export var SETTING_SAVING_FAILED = 'SETTING_SAVING_FAILED';
export var SETTING_SAVING_FINISHED = 'SETTING_SAVING_FINISHED';

// Daily openers

export var DAILYOPENER_LIST_LOADING_STARTED = 'DAILYOPENER_LIST_LOADING_STARTED';
export var DAILYOPENER_LIST_LOADING_FAILED = 'DAILYOPENER_LIST_LOADING_FAILED';
export var DAILYOPENER_LIST_LOADING_FINISHED = 'DAILYOPENER_LIST_LOADING_FINISHED';

export var DAILYOPENER_SAVING_STARTED = 'DAILYOPENER_SAVING_STARTED';
export var DAILYOPENER_SAVING_FAILED = 'DAILYOPENER_SAVING_FAILED';
export var DAILYOPENER_SAVING_FINISHED = 'DAILYOPENER_SAVING_FINISHED';

// Panel Consent

export var PANEL_CONSENT_LOADING_STARTED = 'PANEL_CONSENT_LOADING_STARTED';
export var PANEL_CONSENT_LOADING_FAILED = 'PANEL_CONSENT_LOADING_FAILED';
export var PANEL_CONSENT_LOADING_FINISHED = 'PANEL_CONSENT_LOADING_FINISHED';

export var PANEL_CONSENT_SAVING_STARTED = 'PANEL_CONSENT_SAVING_STARTED';
export var PANEL_CONSENT_SAVING_FAILED = 'PANEL_CONSENT_SAVING_FAILED';
export var PANEL_CONSENT_SAVING_FINISHED = 'PANEL_CONSENT_SAVING_FINISHED';

export var PANEL_CONSENT_CHECK_STARTED = 'PANEL_CONSENT_CHECK_STARTED';
export var PANEL_CONSENT_CHECK_FAILED = 'PANEL_CONSENT_CHECK_FAILED';
export var PANEL_CONSENT_CHECK_FINISHED = 'PANEL_CONSENT_CHECK_FINISHED';

// Reset

export var RESET_ALL = 'RESET_ALL';

// UI transient state clear
export var REQUEST_UI_CLEAR = 'REQUEST_UI_CLEAR';
export var PANELCHANGE_UI_CLEAR = 'PANELCHANGE_UI_CLEAR';
export var PANEL_UI_CLEAR = 'PANEL_UI_CLEAR';
export var TARGET_UI_CLEAR = 'TARGET_UI_CLEAR';
export var TARGET_SEARCH_CLEAR = 'TARGET_SEARCH_CLEAR';
export var ADDRESS_UI_CLEAR = 'ADDRESS_UI_CLEAR';
export var SETTING_UI_CLEAR = 'SETTING_UI_CLEAR';